import MessageService from './MessageService';
import UrlHelper from './UrlHelper';
import SessionService from './SessionService';
import IdentityService from './IdentityService';

export default class RedirectService {
    /**
     * RedirectService constructor
     * @param {MessageService} messageService
     * @param {UrlHelper} urlHelper
     * @param {SessionService} sessionService
     * @param {object} options
     * @param {IdentityService} identityService
     */
    constructor(messageService, urlHelper, sessionService, options, identityService) {
        const { closingData, identityProviderTypeId, dataCollectionHash } = options;

        this.messageService = messageService;
        this.sessionService = sessionService;
        this.identityService = identityService;

        this.urlHelper = urlHelper;

        this._identityProviderTypeId = identityProviderTypeId;
        this._dataCollectionHash = dataCollectionHash;

        this.redirectMessage = closingData.message;
        this.redirectUrl = closingData.redirectUrl;
        this.redirectDelay = closingData.delay;

        this.decliningRedirectUrl = closingData.decliningRedirectUrl;
        this.decliningDelay = closingData.decliningDelay;

        this.failingRedirectUrl = closingData.failingRedirectUrl;
        this.failingDelay = closingData.failingDelay;

        this._redirectTimer = null;

        this._handleWindowClose = true;

        this.enableRedirect = true;

        for (const el of document.getElementsByTagName('noscript')) {
            el.remove();
        }
    }

    disableRedirectLink() {
        document.querySelectorAll('#errors-message a').forEach((link) => {
            link.style.pointerEvents = 'none';
        });

        if (this._redirectTimer !== null) {
            clearTimeout(this._redirectTimer);
            this._redirectTimer = null;
        }

        const counterHolder = document.getElementById('seconds-remained');
        if (counterHolder) {
            counterHolder.innerText = 0;
        }
    }

    handleScreenOut(message, isDeclined, buttons) {
        if (message) {
            this.messageService.displayMessage(message, undefined, buttons);
        }

        if (isDeclined) {
            this._handleWindowClose = false;
            this.redirectDeclinedWithDelay();
        } else {
            this.redirectFailingWithDelay();
        }
    }

    redirectDeclinedWithDelay() {
        if (this.decliningRedirectUrl) {
            this.redirectWithDelay(this.decliningRedirectUrl, this.decliningDelay);
        }
    }

    redirectFailingWithDelay() {
        if (this.failingRedirectUrl) {
            this.redirectWithDelay(this.failingRedirectUrl, this.failingDelay);
        }
    }

    handleSurveyCompleted() {
        this._handleWindowClose = false;

        this.messageService.displayMessage(this.redirectMessage, '', null, true);

        if (this.enableRedirect) {
            this.redirectWithDelay(this.redirectUrl, this.redirectDelay);
        }
    }

    redirectWithDelay(redirectUrl, timeDelay) {
        if (!redirectUrl) {
            return;
        }

        redirectUrl = this.updateRedirectUrl(redirectUrl);
        if (redirectUrl === 'window:close') {
            window.close();
        } else if (redirectUrl !== '') {
            window.providerRedirect = () => {
                window.location.href = redirectUrl;
                this.disableRedirectLink();
            };

            if (this._redirectTimer !== null) {
                clearTimeout(this._redirectTimer);
                this._redirectTimer = null;
                window.providerRedirect();
                return;
            }

            this.messageService.displayRedirectMessage('javascript:window.providerRedirect();', timeDelay);
            if (timeDelay > 0) {
                this._redirectTimer = setTimeout(() => {
                    window.providerRedirect();
                }, timeDelay);
            } else {
                window.providerRedirect();
            }
        }
    }

    updateRedirectUrl(url) {
        const participantId = this.identityService.customParticipantId ||
            this.identityService.participantId ||
            this.identityService.identityKey;

        const _urlParams = this.urlHelper.getUrlSearchParams();

        _urlParams.set('ParticipantID', participantId);
        _urlParams.set('SessionID', this.sessionService.sessionId);
        _urlParams.set('CollectionHash', this._dataCollectionHash);


        for (const [key, value] of _urlParams) {
            url = this.urlHelper.replaceUrlParam(url, key, value);
        }


        return url;
    }

    needHandleWindowClose(value) {
        if (arguments.length > 0)
            this._handleWindowClose = value;
        else
            return this._handleWindowClose;
    }
}
